import { forwardRef } from "react";
import Badge from "@mui/material/Badge";
import { useTheme } from "@mui/material";
import Button from "./Button";
import { useLocation } from "react-router-dom";
import { FONT_WEIGHT_BUTTON } from "../../utils/constants";
import { useIsSlideMenuCollapsed } from "../Menus/SlideMenuCollapsedContext";

const ButtonSlideMenu = forwardRef(
  (
    {
      menu = {},
      children,
      onClick,
      startIcon,
      endIcon,
      sx,
      id,
      ariaLabel,
      collapsedIndicator = false,
    },
    ref
  ) => {
    const location = useLocation();
    const theme = useTheme();
    const isCollapsed = useIsSlideMenuCollapsed();
    const isRouteActive =
      location.pathname === menu.link ||
      (menu.activePathPrefix
        ? location.pathname.startsWith(menu.activePathPrefix)
        : false);
    const shouldShowSelectedStyle =
      isRouteActive && !menu.disabledSelectedStyle;
    const resolvedAriaLabel =
      ariaLabel || (typeof children === "string" ? children : undefined);
    const resolvedStartIcon =
      isCollapsed && collapsedIndicator ? (
        <Badge variant="dot" color="error" overlap="circular">
          {startIcon}
        </Badge>
      ) : (
        startIcon
      );

    const sxButtonSlideMenu = {
      border: "none",
      boxShadow: "none",
      justifyContent: isCollapsed ? "center" : "left",
      width: isCollapsed ? "48px !important" : "100% !important",
      fontWeight: FONT_WEIGHT_BUTTON,
      "& .MuiSvgIcon-root": {
        marginLeft: isCollapsed ? 0 : "8px",
        color: shouldShowSelectedStyle
          ? "#fff !important"
          : "background.paperContrastText",
      },
      "& .MuiButton-startIcon svg": {
        color: shouldShowSelectedStyle
          ? "#fff !important"
          : "background.paperContrastText",
      },
      "&:hover": {
        backgroundColor: shouldShowSelectedStyle
          ? theme.palette.button.primary.main
          : "transparent",
      },
    };

    const button = (
      <Button
        id={id}
        refButton={ref}
        hasShadow={false}
        color={shouldShowSelectedStyle ? "primary" : "secondary"}
        variant="contained"
        disableElevation
        fullWidth
        iconOnly={isCollapsed}
        ariaLabel={isCollapsed ? resolvedAriaLabel : ariaLabel}
        startIcon={resolvedStartIcon}
        endIcon={isCollapsed ? undefined : endIcon}
        sx={{
          ...sxButtonSlideMenu,
          ...sx,
        }}
        onClick={onClick}
      >
        {isCollapsed ? null : children}
      </Button>
    );

    return button;
  }
);

ButtonSlideMenu.displayName = "ButtonSlideMenu";

export default ButtonSlideMenu;
